import DailyAggregateTable, { type DailyAggregateConfig, type DailyAggregateExtraColumn } from '../../../components/DailyAggregateTable';
import { LocalStorageKeys } from '../../../util/constants';

const POS_COLUMN: DailyAggregateExtraColumn = {
	accessorKey: 'depot',
	headerKey: 'common:tables.pos',
};

const SALES_FAMILY_CONFIG: DailyAggregateConfig = {
	storageKey: LocalStorageKeys.SALES_FAMILY_RECORDS,
	headerKey: 'common:sales.headers.byFamilyDaily',
	endpoint: 'sales/families',
	exportPrefix: 'sales_by_family',
	dimensionKey: 'family',
	dimensionHeaderKey: 'common:tables.family',
	extraColumns: [POS_COLUMN],
};

const SALES_CATEGORY_CONFIG: DailyAggregateConfig = {
	storageKey: LocalStorageKeys.SALES_CATEGORY_RECORDS,
	headerKey: 'common:sales.headers.byCategoryDaily',
	endpoint: 'sales/categories',
	exportPrefix: 'sales_by_category',
	dimensionKey: 'category',
	dimensionHeaderKey: 'common:tables.category',
	extraColumns: [POS_COLUMN],
};

const SALES_DEPOT_CONFIG: DailyAggregateConfig = {
	storageKey: LocalStorageKeys.SALES_DEPOT_RECORDS,
	headerKey: 'common:sales.headers.byDepotDaily',
	endpoint: 'sales/depots',
	exportPrefix: 'sales_by_depot',
	dimensionKey: 'depot',
	dimensionHeaderKey: 'common:tables.pos',
};

const SALES_SECTOR_CONFIG: DailyAggregateConfig = {
	storageKey: LocalStorageKeys.SALES_SECTOR_RECORDS,
	headerKey: 'common:sales.headers.bySectorDaily',
	endpoint: 'sales/sectors',
	exportPrefix: 'sales_by_sector',
	dimensionKey: 'sector',
	dimensionHeaderKey: 'common:tables.sector',
	extraColumns: [POS_COLUMN],
};

const SALES_USER_CONFIG: DailyAggregateConfig = {
	storageKey: LocalStorageKeys.SALES_USER_RECORDS,
	headerKey: 'common:sales.headers.byUserDaily',
	endpoint: 'sales/users',
	exportPrefix: 'sales_by_user',
	dimensionKey: 'user',
	dimensionHeaderKey: 'common:tables.user',
	extraColumns: [POS_COLUMN],
};

export const SalesFamilyDaily = () => <DailyAggregateTable config={SALES_FAMILY_CONFIG} />;
export const SalesCategoryDaily = () => <DailyAggregateTable config={SALES_CATEGORY_CONFIG} />;
export const SalesDepotDaily = () => <DailyAggregateTable config={SALES_DEPOT_CONFIG} />;
export const SalesSectorDaily = () => <DailyAggregateTable config={SALES_SECTOR_CONFIG} />;
export const SalesUserDaily = () => <DailyAggregateTable config={SALES_USER_CONFIG} />;